import { Injectable } from '@angular/core';
import {
  AbstractListComponentStore,
  ListState,
  listInitialState,
} from '../../../core/state/base-component-stores/abstract-list.component-store';
import { HttpFeaturedTestimonyService } from '../../../core/services/http/http-featured-testimony.service';
import { skip, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/component-store';
import { convertHttpErrorToApiError } from '../../models/api-results/error.api-result';

import { FeaturedTestimonyPublicationStatus } from '../../models/enums/publication-status.enums';
import { FeaturedTestimonyResult } from '../../models/api-results/abstract-testimony/featured-testimony.api-result';
import { FeaturedTestimony } from '../../models/entities/testimony/featured-testimony.entity';
import {
  FeaturedTestimonyFiltersFormValue,
  FeaturedTestimonyQueryData,
} from '../../models/payloads/testimony/featured-testimony.payload';

export interface FeaturedTestimoniesSliderState extends ListState<FeaturedTestimonyResult> {
  filtersFormValue: FeaturedTestimonyFiltersFormValue;
}

export const initialState: FeaturedTestimoniesSliderState = {
  ...listInitialState,
  filtersFormValue: {
    ...listInitialState.filtersFormValue,
    publicationStatus: [
      FeaturedTestimonyPublicationStatus.PUBLISHED,
      FeaturedTestimonyPublicationStatus.PUBLISHED_ON_LANDING,
    ],
  },
};

@Injectable()
export class FeaturedTestimoniesSliderStoreService extends AbstractListComponentStore<FeaturedTestimoniesSliderState> {
  constructor(private httpFeaturedTestimonyService: HttpFeaturedTestimonyService) {
    super(initialState);
  }

  // SELECTORS

  entities$ = this.select((state) =>
    state.entities['hydra:member'].map((elt) => new FeaturedTestimony(elt))
  );

  // EFFECTS

  listApiCall(filtersFormValue: FeaturedTestimonyFiltersFormValue) {
    return this.httpFeaturedTestimonyService.list(new FeaturedTestimonyQueryData(filtersFormValue));
  }
}
